import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {Post} from "../../../../shared/interface/post";
import {Support} from "../../../../shared/interface/support";
import {HttpErrorResponse} from "@angular/common/http";
import {PostService} from "../../../../shared/services/post.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-post-details',
  templateUrl: './post-details.component.html',
  styleUrls: ['./post-details.component.scss']
})
export class PostDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  postId: string;
  postObject?: Post;
  post: ReplaySubject<Post> = new ReplaySubject<Post>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private postService: PostService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.postId = params.id;
        this.loadPost();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadPost(): void {
    this.postService.get(this.postId).subscribe((post: Post) => {
      this.post.next(post);
      this.postObject = post;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }
  
}
